import PropTypes from 'prop-types'

import useNexiaStream from 'hooks/useNexiaStream'

import SystemStatusPanel from 'pages/Device/SystemStatusPanel'
import ZoneStatusPanel from 'pages/Device/ZoneStatusPanel'

const propTypes = {
  deviceId: PropTypes.string.isRequired,
  hasAwairDevice: PropTypes.bool.isRequired,
  reportCache: PropTypes.shape().isRequired
}

const Status = ({ deviceId, hasAwairDevice, reportCache }) => {
  const { eventData: report } = useNexiaStream(deviceId, 'current_status', reportCache)

  return (
    <>
      <SystemStatusPanel report={report} hasAwairDevice={hasAwairDevice} />
      {report && report.zones.length > 1 && <ZoneStatusPanel {...{ ...report, ...hasAwairDevice }} />}
    </>
  )
}

Status.propTypes = propTypes

export default Status
